var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isEdit && _vm.cooperateEdit,
              expression: "!isEdit && cooperateEdit"
            }
          ],
          staticStyle: { padding: "5px 0" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.export7501(true)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.customer")) + "7501")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.export7501()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.CustomsClearance")) + "7501")]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "generateCostCharge", type: "primary" },
              on: { click: _vm.generateCostCharge }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.GenerateReceivableExpense")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "generateSellingCharge", type: "primary" },
              on: { click: _vm.generateSellingCharge }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.GeneratePayableExpenses")))]
          ),
          (_vm.job.lob === "SE" || _vm.job.lob === "AE") &&
          _vm.readonly &&
          _vm.showSync
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.exportSyncImport }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit && _vm.cooperateEdit,
              expression: "isEdit && cooperateEdit"
            }
          ],
          staticStyle: { padding: "5px 0" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "clearData", type: "primary" },
              on: { click: _vm.clearData }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EmptyData")))]
          ),
          _vm.$checkPermission(["tab_UsCustomsClearance_customerEdit"])
            ? _c(
                "el-button",
                {
                  attrs: { no: "CopyAsCustomerData", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toCopy(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("queryJob.CopyAsCustomerData")))]
              )
            : _vm._e(),
          _vm.$checkPermission(["tab_UsCustomsClearance_reportEdit"])
            ? _c(
                "el-button",
                {
                  attrs: { no: "CopyAsDeclarationData", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toCopy(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("queryJob.CopyAsDeclarationData")))]
              )
            : _vm._e(),
          _vm.$checkPermission(["tab_UsCustomsClearance_secretEdit"])
            ? _c(
                "el-button",
                {
                  attrs: { no: "CopyAsTopSecretInformation", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toCopy(3)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("queryJob.CopyAsTopSecretInformation")))]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: { disabled: !_vm.isEdit || !_vm.cooperateEdit }
        },
        [
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v(" " + _vm._s(_vm.$t("queryJob.PdfType")) + " ")
            ]),
            _c("div", { staticClass: "w-180" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataType")))
            ])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { no: "pdfType" },
                    model: {
                      value: _vm.form.pdfType,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "pdfType", $$v)
                      },
                      expression: "form.pdfType"
                    }
                  },
                  [
                    _c("el-option", { attrs: { value: "PAPERLESS" } }),
                    _c("el-option", { attrs: { value: "CENSUS WARNING" } })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180", staticStyle: { "line-height": "28px" } },
              [_vm._v(_vm._s(_vm._f("filterDataType")(_vm.form.dataType)))]
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("1. FilerCode / Entry No")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("2. Entry Type")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("3. Summary Date ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("3.1. - Code")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("4. Surety No")
            ]),
            _c("div", { staticClass: "w-180" }, [_vm._v("5. Bond Type")])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "filerCode", maxlength: "20" },
                  model: {
                    value: _vm.form.filerCode,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "filerCode", $$v)
                    },
                    expression: "form.filerCode"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "entryType", maxlength: "20" },
                  model: {
                    value: _vm.form.entryType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "entryType", $$v)
                    },
                    expression: "form.entryType"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "summaryDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.summaryDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "summaryDate", $$v)
                    },
                    expression: "form.summaryDate"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "code", maxlength: "5" },
                  model: {
                    value: _vm.form.code,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "code", $$v)
                    },
                    expression: "form.code"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "suretyNo", maxlength: "5" },
                  model: {
                    value: _vm.form.suretyNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "suretyNo", $$v)
                    },
                    expression: "form.suretyNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-input", {
                  attrs: { no: "bondType", maxlength: "5" },
                  model: {
                    value: _vm.form.bondType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "bondType", $$v)
                    },
                    expression: "form.bondType"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("6. Port Code ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("7. Entry Date ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("8. Importing Carrier ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("9. Mode of Transport ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("10. Country of Origin")
            ]),
            _c("div", { staticClass: "w-180" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("11. Import Date ")
            ])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { no: "portCode", filterable: "" },
                    model: {
                      value: _vm.form.portCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "portCode", $$v)
                      },
                      expression: "form.portCode"
                    }
                  },
                  _vm._l(_vm.amsPortList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "entryDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.entryDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "entryDate", $$v)
                    },
                    expression: "form.entryDate"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "importingCarrier", maxlength: "50" },
                  model: {
                    value: _vm.form.importingCarrier,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "importingCarrier", $$v)
                    },
                    expression: "form.importingCarrier"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: {
                    no: "modeOfTransport",
                    value: _vm.form.modeOfTransport
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("cargo-advance-select", {
                  attrs: {
                    no: "countryOfOrigin",
                    "select-type": _vm.TYPE_NAMES.basic_data_Country,
                    filterable: "",
                    "tag-name": "code",
                    "default-value": _vm.form.countryOfOrigin
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.form.countryOfOrigin = p.value
                      _vm.toStatistics()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "importDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.importDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "importDate", $$v)
                    },
                    expression: "form.importDate"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("12. B/L or AWB No ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("13. Manufacturer ID")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("14. Exporting Country")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("15. Export Date ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("16. I.T. No")
            ]),
            _c("div", { staticClass: "w-180" }, [_vm._v("17. I.T. Date")])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "blAwbNo", maxlength: "30" },
                  model: {
                    value: _vm.form.blAwbNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "blAwbNo", $$v)
                    },
                    expression: "form.blAwbNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "manufacturerId", maxlength: "20" },
                  model: {
                    value: _vm.form.manufacturerId,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "manufacturerId", $$v)
                    },
                    expression: "form.manufacturerId"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("cargo-advance-select", {
                  attrs: {
                    no: "exportingCountry",
                    "select-type": _vm.TYPE_NAMES.basic_data_Country,
                    filterable: "",
                    "tag-name": "code",
                    "default-value": _vm.form.exportingCountry
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.form.exportingCountry = p.value
                      _vm.form.showChinaSurtax = p.value === "CN"
                      _vm.toStatistics()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "exportDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.exportDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "exportDate", $$v)
                    },
                    expression: "form.exportDate"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "itNo", maxlength: "20" },
                  model: {
                    value: _vm.form.itNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "itNo", $$v)
                    },
                    expression: "form.itNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "itDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.itDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "itDate", $$v)
                    },
                    expression: "form.itDate"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("18. Missing Docs")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("19. Foreign Port of Lading")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("20. U.S. Port of Unlading ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("21. Location of Goods/G.O. No ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("21.1. - Select")
            ]),
            _c("div", { staticClass: "w-180" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("21.2. - Code ")
            ])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "missingDocs", maxlength: "20" },
                  model: {
                    value: _vm.form.missingDocs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "missingDocs", $$v)
                    },
                    expression: "form.missingDocs"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "foreignPortOfLading",
                      filterable: "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.form.foreignPortOfLading,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "foreignPortOfLading", $$v)
                      },
                      expression: "form.foreignPortOfLading"
                    }
                  },
                  _vm._l(_vm.amsPortList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { no: "usPortOfUnlading", filterable: "" },
                    model: {
                      value: _vm.form.usPortOfUnlading,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "usPortOfUnlading", $$v)
                      },
                      expression: "form.usPortOfUnlading"
                    }
                  },
                  _vm._l(_vm.amsPortList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { value: item.code }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "locationOfGoods",
                      filterable: "",
                      "allow-create": ""
                    },
                    model: {
                      value: _vm.form.locationOfGoods,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "locationOfGoods", $$v)
                      },
                      expression: "form.locationOfGoods"
                    }
                  },
                  [
                    _vm.job.lob === "SE" || _vm.job.lob === "SI"
                      ? [
                          _c("el-option", { attrs: { value: "Z773" } }),
                          _c("el-option", { attrs: { value: "Z952" } }),
                          _c("el-option", { attrs: { value: "W185" } }),
                          _c("el-option", { attrs: { value: "WAC8" } }),
                          _c("el-option", { attrs: { value: "L005" } }),
                          _c("el-option", { attrs: { value: "E364" } }),
                          _c("el-option", { attrs: { value: "P486" } }),
                          _c("el-option", { attrs: { value: "J830" } }),
                          _c("el-option", { attrs: { value: "L737" } })
                        ]
                      : _vm.job.lob === "AE" || _vm.job.lob === "AI"
                      ? [
                          _c("el-option", { attrs: { value: "E811" } }),
                          _c("el-option", { attrs: { value: "Z510" } })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "choose", value: _vm.form.choose }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-input", {
                  attrs: { no: "code2", maxlength: "10" },
                  model: {
                    value: _vm.form.code2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "code2", $$v)
                    },
                    expression: "form.code2"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("22. Consignee No")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("23. Importer No")
            ]),
            _c("div", { staticClass: "w-180" }, [_vm._v("24. Reference No")])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "consigneeNo", maxlength: "20" },
                  model: {
                    value: _vm.form.consigneeNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "consigneeNo", $$v)
                    },
                    expression: "form.consigneeNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "importerNo", maxlength: "20" },
                  model: {
                    value: _vm.form.importerNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "importerNo", $$v)
                    },
                    expression: "form.importerNo"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-input", {
                  attrs: { no: "referenceNo", maxlength: "20" },
                  model: {
                    value: _vm.form.referenceNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "referenceNo", $$v)
                    },
                    expression: "form.referenceNo"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-600 mRight-30" }, [
              _vm._v("25. Ultimate Consignee Name and Address")
            ]),
            _c("div", { staticClass: "w-285 mRight-30" }, [
              _vm._v("25.1. - Address")
            ]),
            _c("div", { staticClass: "w-285" }, [
              _vm._v("25.2. - Address - Detail")
            ])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-600 mRight-30" },
              [
                _c("el-input", {
                  attrs: {
                    no: "ultimateConsigneeNameAndAddress",
                    maxlength: "100"
                  },
                  model: {
                    value: _vm.form.ultimateConsigneeNameAndAddress,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ultimateConsigneeNameAndAddress", $$v)
                    },
                    expression: "form.ultimateConsigneeNameAndAddress"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-285 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "address", maxlength: "100" },
                  model: {
                    value: _vm.form.address,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "address", $$v)
                    },
                    expression: "form.address"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-285" },
              [
                _c("el-input", {
                  attrs: { no: "addressDetail", maxlength: "100" },
                  model: {
                    value: _vm.form.addressDetail,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "addressDetail", $$v)
                    },
                    expression: "form.addressDetail"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("25.3. - Destination")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _c("span", { staticStyle: { color: "red" } }, [_vm._v("* ")]),
              _vm._v("25.4. - Customer Reference# ")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("25.5. - City")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("25.6. - State")
            ]),
            _c("div", { staticClass: "w-180" }, [_vm._v("25.7. - Zip")])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "destination", maxlength: "100" },
                  model: {
                    value: _vm.form.destination,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "destination", $$v)
                    },
                    expression: "form.destination"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "customerReference", maxlength: "100" },
                  model: {
                    value: _vm.form.customerReference,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customerReference", $$v)
                    },
                    expression: "form.customerReference"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "city", maxlength: "20" },
                  model: {
                    value: _vm.form.city,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "city", $$v)
                    },
                    expression: "form.city"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "state", maxlength: "20" },
                  model: {
                    value: _vm.form.state,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state", $$v)
                    },
                    expression: "form.state"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-input", {
                  attrs: { no: "zip", maxlength: "10" },
                  model: {
                    value: _vm.form.zip,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "zip", $$v)
                    },
                    expression: "form.zip"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-600 mRight-30" }, [
              _vm._v("26. Importer of Record Name and Address")
            ]),
            _c("div", { staticClass: "w-285 mRight-30" }, [
              _vm._v("26.1. - Address")
            ]),
            _c("div", { staticClass: "w-285" }, [
              _vm._v("26.2. - Address - Detail")
            ])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-600 mRight-30" },
              [
                _c("el-input", {
                  attrs: {
                    no: "importerOfRecordNameAndAddress",
                    maxlength: "100"
                  },
                  model: {
                    value: _vm.form.importerOfRecordNameAndAddress,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "importerOfRecordNameAndAddress", $$v)
                    },
                    expression: "form.importerOfRecordNameAndAddress"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-285 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "address2", maxlength: "100" },
                  model: {
                    value: _vm.form.address2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "address2", $$v)
                    },
                    expression: "form.address2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-285" },
              [
                _c("el-input", {
                  attrs: { no: "addressDetail2", maxlength: "100" },
                  model: {
                    value: _vm.form.addressDetail2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "addressDetail2", $$v)
                    },
                    expression: "form.addressDetail2"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("26.3. - City")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("26.4. - State")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("26.5. - Zip")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v("Total Quantity")
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [_vm._v("- Unit")]),
            _c("div", { staticClass: "w-180" }, [_vm._v("Signature Date")])
          ]),
          _c("div", { staticClass: "flex-row-content" }, [
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "city2", maxlength: "20" },
                  model: {
                    value: _vm.form.city2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "city2", $$v)
                    },
                    expression: "form.city2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "state2", maxlength: "20" },
                  model: {
                    value: _vm.form.state2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "state2", $$v)
                    },
                    expression: "form.state2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input", {
                  attrs: { no: "zip2", maxlength: "10" },
                  model: {
                    value: _vm.form.zip2,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "zip2", $$v)
                    },
                    expression: "form.zip2"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("el-input-number", {
                  attrs: { no: "totalQuantity", precision: 2, controls: false },
                  model: {
                    value: _vm.form.totalQuantity,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "totalQuantity", $$v)
                    },
                    expression: "form.totalQuantity"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180 mRight-30" },
              [
                _c("cargo-advance-select", {
                  attrs: {
                    no: "unit",
                    "select-type": _vm.TYPE_NAMES.basic_data_Packing,
                    filterable: "",
                    "default-value": _vm.form.unit
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.form.unit = p.value
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "w-180" },
              [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "signatureDate",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                    format: "MM/dd/yy",
                    clearable: ""
                  },
                  model: {
                    value: _vm.form.signatureDate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "signatureDate", $$v)
                    },
                    expression: "form.signatureDate"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex-row-label" }, [
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.MergeProductNamesWhenFiles")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowTax")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowChinaSurtax")))
            ]),
            _c("div", { staticClass: "w-180 mRight-30" }, [
              _vm._v(_vm._s(_vm.$t("queryJob.ShowMargin")))
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.showBond,
                    expression: "form.showBond"
                  }
                ],
                staticClass: "w-180"
              },
              [_vm._v(_vm._s(_vm.$t("queryJob.MarginAmount")))]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "flex-row-content",
              staticStyle: { "line-height": "31px" }
            },
            [
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "generatingFileMergeSameProduct" },
                    on: { change: _vm.toStatistics },
                    model: {
                      value: _vm.form.generatingFileMergeSameProduct,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "generatingFileMergeSameProduct",
                          $$v
                        )
                      },
                      expression: "form.generatingFileMergeSameProduct"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showTax" },
                    model: {
                      value: _vm.form.showTax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showTax", $$v)
                      },
                      expression: "form.showTax"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showChinaSurtax" },
                    on: { change: _vm.toStatistics },
                    model: {
                      value: _vm.form.showChinaSurtax,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showChinaSurtax", $$v)
                      },
                      expression: "form.showChinaSurtax"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-180 mRight-30" },
                [
                  _c("el-switch", {
                    attrs: { no: "showBond" },
                    on: {
                      change: function($event) {
                        _vm.form.bondAmount = _vm.form.showBond
                          ? _vm.form.bondAmount
                          : 0
                      }
                    },
                    model: {
                      value: _vm.form.showBond,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showBond", $$v)
                      },
                      expression: "form.showBond"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.showBond,
                      expression: "form.showBond"
                    }
                  ],
                  staticClass: "w-180"
                },
                [
                  _c("el-input-number", {
                    attrs: { no: "bondAmount", precision: 2, controls: false },
                    model: {
                      value: _vm.form.bondAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "bondAmount", $$v)
                      },
                      expression: "form.bondAmount"
                    }
                  })
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit && _vm.cooperateEdit,
              expression: "isEdit && cooperateEdit"
            }
          ]
        },
        [
          _c(
            "el-button",
            { attrs: { no: "new", type: "primary" }, on: { click: _vm.toAdd } },
            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
          ),
          _c(
            "el-button",
            {
              attrs: {
                no: "delete",
                disabled: !_vm.selectedNode,
                type: "danger"
              },
              on: { click: _vm.toDelete }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: {
          height: "300px",
          "min-height": "300px",
          "margin-top": "5px"
        },
        attrs: {
          "config-module": "130121",
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        {
          staticClass: "flex-row-label",
          staticStyle: { "margin-top": "20px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalPacking")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("queryJob.TotalNetWeight")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalWeight")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalCubage")))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v(_vm._s(_vm.$t("queryJob.TotalValue")))
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "flex-row-content",
          staticStyle: { "line-height": "28px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalPack))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalNetWeight))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalGrossWeight))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalVolume))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v(_vm._s(_vm.form.totalNumber))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v(_vm._s(_vm.form.totalCargoValue.toFixed(4)))
          ])
        ]
      ),
      _c("div", { staticClass: "flex-row-label" }, [
        _c("div", { staticClass: "w-180 mRight-30" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.TotalTariff")))
        ]),
        _c("div", { staticClass: "w-180 mRight-30" }, [
          _vm._v(_vm._s(_vm.$t("queryJob.TotalOtherExpenses")))
        ]),
        _c("div", { staticClass: "w-180" }, [
          _vm._v(_vm._s(_vm.$t("WriteOff.total")))
        ])
      ]),
      _c(
        "div",
        {
          staticClass: "flex-row-content",
          staticStyle: { "line-height": "28px" }
        },
        [
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v("$" + _vm._s(_vm.form.totalTariff.toFixed(2)))
          ]),
          _c("div", { staticClass: "w-180 mRight-30" }, [
            _vm._v("$" + _vm._s(_vm.form.otherTotalCharge.toFixed(2)))
          ]),
          _c("div", { staticClass: "w-180" }, [
            _vm._v("$" + _vm._s(_vm.form.total.toFixed(2)))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }